import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于新新漫画，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqData.map((item, i) => (
            <details key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between gap-3 p-5 md:p-6 cursor-pointer list-none">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-6">
                  {item.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm transition-all"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-0">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}